// The portal's published support contact (the address the Terms page names).
// One constant, so a page that tells someone "who to contact" cannot drift
// from the next one (BRK-S325).
export const SUPPORT_EMAIL = "support@signalspecialty.com";
